import axiosInstance from '../axios/axiosInstance';
import { ExamImportRequest } from '../model/request';

export const docImport = async (file: any, examTemplateId: string, practice: boolean) => {
  const bodyFormData = new FormData();
  bodyFormData.append('fileUpload', file);
  const { data } = await axiosInstance<ExamImportRequest>({
    method: 'post',
    url: 'import/doc',
    data: bodyFormData,
    headers: { 'Content-Type': 'multipart/form-data' },
    params: { examTemplateId, practice },
  });
  return data;
};
